/**
 * bt-send-queue — sérialise les envois vers une même imprimante Bluetooth.
 *
 * Depuis l'envoi par service (PR #372), un « Envoyer » du pad déclenche N bons
 * en parallèle (un par course) sur le MÊME socket SPP. Sans file d'attente,
 * les `write` se chevauchent : bon tronqué, commande de coupe (GS V) noyée
 * dans le flux du bon suivant — retour terrain WAVE 2026-09-10 (« le bon
 * s'arrête trop tôt et ne coupe plus »).
 *
 * Une chaîne de promesses par clé (MAC) : chaque envoi attend la fin du
 * précédent, y compris son délai de flush. Un envoi en échec ne bloque pas
 * les suivants.
 */

const chains = new Map<string, Promise<unknown>>();

export function enqueueSend<T>(key: string, task: () => Promise<T>): Promise<T> {
  const previous = chains.get(key) ?? Promise.resolve();
  const run = previous.then(task, task);
  // La chaîne mémorise un résultat neutralisé : l'échec d'un envoi ne doit
  // pas rejeter les envois suivants.
  const settled = run.then(
    () => undefined,
    () => undefined,
  );
  chains.set(key, settled);
  void settled.then(() => {
    if (chains.get(key) === settled) chains.delete(key);
  });
  return run;
}

/** Nombre de files vivantes — exposé pour les tests. */
export function pendingQueues(): number {
  return chains.size;
}
